import { useCallback } from 'react';
import { LevelSystem } from '@typings/pets/pet.interface';

export const getMaxExpForLevel = (level: number, system?: LevelSystem | null): number => {
  if (!system || !Array.isArray(system.levelRequirements) || system.levelRequirements.length === 0) {
    return Math.max(100, level * 100);
  }
  const idx = Math.max(0, Math.min(system.levelRequirements.length - 1, (Number(level || 1) - 1)));
  return Number(system.levelRequirements[idx] || 0);
};

export const computeLevelFromExp = (exp: number, system?: LevelSystem | null): number => {
  if (!system || !Array.isArray(system.levelRequirements) || system.levelRequirements.length === 0) {
    return Math.floor(exp / 100) + 1; // 폴백: 100 당 1레벨
  }
  let nextLevel = 1;
  for (let i = 0; i < system.levelRequirements.length; i++) {
    // i=0 은 Lv.2 임계치 → 달성 시 nextLevel=2
    if (exp >= Number(system.levelRequirements[i] || 0)) nextLevel = i + 2;
  }
  const maxLv = Number((system as any)?.maxLevel || 0);
  if (Number.isFinite(maxLv) && maxLv > 0) {
    nextLevel = Math.min(nextLevel, maxLv);
  }
  return Math.max(1, nextLevel);
};

export default function useLevelCheck(levelSystem?: LevelSystem | null) {
  const getMaxExpForLevelCb = useCallback((level: number) => getMaxExpForLevel(level, levelSystem), [levelSystem]);
  const computeLevelFromExpCb = useCallback((exp: number) => computeLevelFromExp(exp, levelSystem), [levelSystem]);
  const isExpMaxForLevel = useCallback((exp: number, level: number) => {
    const max = getMaxExpForLevelCb(level);
    return max > 0 && Number(exp || 0) >= max;
  }, [getMaxExpForLevelCb]);

  const isLevelUp = useCallback((exp: number, currentLevel: number) => {
    const next = computeLevelFromExpCb(exp);
    return next > Number(currentLevel || 1);
  }, [computeLevelFromExpCb]);

  return { getMaxExpForLevel: getMaxExpForLevelCb, computeLevelFromExp: computeLevelFromExpCb, isExpMaxForLevel, isLevelUp };
}


